import { gql } from "apollo-boost";

export const CREATE_EXCHANGERATE = gql`
  mutation CreateExchangeRate($data: ExchangeRateInput) {
    createExchangeRate(data: $data) {
      id
    }
  }
`;

export const UPDATE_EXCHANGERATE = gql`
  mutation UpdateExchangeRate(
    $where: ExchangeRateWhereInputOne!
    $data: ExchangeRateInput
  ) {
    updateExchangeRate(where: $where, data: $data) {
      id
    }
  }
`;
